import intl from 'react-intl-universal';
import { DynamicForm, Modal } from '@/components';
import {
    ProFormColumnsType,
    ProFormInstance,
} from '@ant-design/pro-components';
import { getIpList } from '@/api/softPhone';

interface Props {
    show: boolean;
    pauseStatus: any[];
    onLogin?: (params) => void;
    onClose?: () => void;
}

// import style from '../index.less';
import { useEffect, useRef, useState } from 'react';
const Login: React.FC<Props> = ({
    show = false,
    pauseStatus,
    onLogin,
    onClose,
}) => {
    const [options, setOptions] = useState<{ value: string; label: string }[]>(
        [],
    );
    const [bindType, setbindType] = useState(2);
    const formRef = useRef<ProFormInstance>();

    useEffect(() => {
        if (show) {
            setbindType(2);
        }
    }, [show]);

    useEffect(() => {
        getIpList({
            current: 1,
            pageSize: 100,
            type: bindType === 2 ? 1 : 2,
        }).then((res) => {
            setOptions(
                res.data?.map((item) => ({
                    label: item.extenNumber,
                    value: item.extenNumber,
                })),
            );
        });
    }, [bindType]);

    const columns: ProFormColumnsType[] = [
        {
            dataIndex: 'bindType',
            title: intl.get('电话类型'),
            valueType: 'radio',
            fieldProps: {
                onChange: (e) => {
                    setbindType(e.target.value);
                    formRef.current?.setFieldValue('bindTel', undefined);
                },
                options: [
                    {
                        value: 2,
                        label: intl.get('ip话机'),
                    },
                    {
                        value: 3,
                        label: intl.get('软电话'),
                    },
                ],
            },
            formItemProps: {
                rules: [
                    {
                        required: true,
                        message: intl.get('请选择电话类型'),
                    },
                ],
            },
        },
        {
            valueType: 'dependency',
            name: ['bindType'],
            dataIndex: 'bindTel',
            columns: ({ bindType }) => {
                console.log('bindType', bindType);
                return [
                    {
                        dataIndex: 'bindTel',
                        title: intl.get('绑定电话'),
                        valueType: 'select',
                        // params: { bindType },
                        fieldProps: {
                            showSearch: true,
                            placeholder: intl.get('请选择绑定电话'),
                            options,
                        },
                        // request: async (params) => {
                        //     const res = await getIpList({
                        //         current: 1,
                        //         pageSize: 100,
                        //         type: bindType === 2 ? 1 : 2,
                        //     });
                        //     return res.data?.map((item) => ({
                        //         label: item.extenNumber,
                        //         value: item.extenNumber,
                        //     }));
                        // },
                        formItemProps: {
                            rules: [
                                {
                                    required: true,
                                    message: intl.get('请选择电话'),
                                },
                            ],
                        },
                    },
                ];
            },
        },

        {
            dataIndex: 'loginStatus',
            title: intl.get('初始状态'),
            valueType: 'radio',
            formItemProps: {
                rules: [
                    {
                        required: true,
                        message: intl.get('请选择初始状态'),
                    },
                ],
            },
            fieldProps: {
                options: [
                    {
                        value: 1,
                        label: intl.get('空闲'),
                    },
                    ...pauseStatus?.map((item) => {
                        return {
                            label: item.pauseStatus,
                            value: item.pauseStatus,
                        };
                    }),
                ],
            },
        },
        // {
        //     dataIndex: 'password',
        //     title: '密码',
        //     formItemProps: {
        //         rules: [
        //             {
        //                 required: true,
        //                 message: '请输入密码',
        //             },
        //         ],
        //     },
        // },
    ];

    const onFinish = async (values) => {
        return await onLogin?.(values);
    };

    return (
        <Modal
            title={intl.get('初始化配置')}
            open={show}
            // onOk={handleOk}
            onCancel={onClose}
            footer={null}
            destroyOnClose={true}
        >
            <DynamicForm
                ref={formRef}
                className="modalForm"
                labelCol={{ span: 6 }}
                columns={columns}
                onFinish={onFinish}
                initialValues={{
                    bindType: 2,
                    loginStatus: pauseStatus.length
                        ? pauseStatus[0].pauseStatus
                        : 1,
                }}
                submitter={{
                    searchConfig: {
                        resetText: intl.get('取消'),
                        submitText: intl.get('确认'),
                    },
                    onReset: () => {
                        onClose?.();
                    },
                }}
            />
        </Modal>
    );
};

export default Login;
